import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { Props, SelectOptGroupProps, SelectOptionProps } from './select.type';

import './select.css';

export const SelectOptGroup = ({ children, ...props }: SelectOptGroupProps) => {
  return <optgroup {...props}>{children}</optgroup>;
};

export const SelectOption = ({ value, label, ...props }: SelectOptionProps) => {
  return (
    <option value={value} label={label} {...props}>
      {label}
    </option>
  );
};

export const Select = forwardRef(
  (
    { hasError, isEmpty, selectFontLight, children, readOnly, ...props }: Props,
    ref: ForwardedRef<HTMLSelectElement>
  ) => {
    return (
      <select
        {...props}
        className={classNames(
          {
            'border-soft focus:border-medium': !hasError,
            'border-critical-no-bg': hasError,
            'cursor-not-allowed bg-tertiary pointer-events-none opacity-50': readOnly,
            'fill-primary': !readOnly,
            'text-tertiary': isEmpty,
            'text-primary': !isEmpty,
            'text-subtitle-m': !selectFontLight,
            'text-body-m': selectFontLight,
          },
          'select w-full py-3 pl-3 pr-8 rounded-md border text-body-m placeholder:text-tertiary focus:outline-hidden focus:ring-0'
        )}
        ref={ref}>
        {children}
      </select>
    );
  }
);

export const SelectWithOptions = forwardRef(
  (
    {
      hasError,
      isEmpty,
      selectFontLight,
      options,
      readOnly,
      ...props
    }: Props & { options: { value: string | number; label: string }[] },
    ref: ForwardedRef<HTMLSelectElement>
  ) => {
    return (
      <select
        {...props}
        className={classNames(
          {
            'border-soft focus:border-medium': !hasError,
            'border-critical-no-bg': hasError,
            'cursor-not-allowed bg-tertiary': readOnly,
            'fill-primary': !readOnly,
            'text-tertiary': isEmpty,
            'text-primary': !isEmpty,
            'text-subtitle-m': !selectFontLight,
            'text-body-m': selectFontLight,
          },
          'select w-full py-3 pl-3 pr-8 rounded-md border text-body-m placeholder:text-tertiary focus:outline-hidden focus:ring-0'
        )}
        ref={ref}>
        {options.map((option, index) => (
          <SelectOption key={`option-${index}-${option.value}`} value={option.value} label={option.label} />
        ))}
      </select>
    );
  }
);
